import { render, staticRenderFns } from "./AboutDivas.vue?vue&type=template&id=797991fe&scoped=true&"
import script from "./AboutDivas.vue?vue&type=script&lang=js&"
export * from "./AboutDivas.vue?vue&type=script&lang=js&"
import style0 from "./AboutDivas.vue?vue&type=style&index=0&id=797991fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797991fe",
  null
  
)

component.options.__file = "AboutDivas.vue"
export default component.exports